import { render, staticRenderFns } from "./DepartmentEmployee.vue?vue&type=template&id=52fcd501"
import script from "./DepartmentEmployee.vue?vue&type=script&lang=js"
export * from "./DepartmentEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports